import _ from 'underscore'
import WMenu from '../components/WMenu'
import WMenuMixin from './w-menu-mixin'
import WColorMixin from "./w-color-mixin";

/**
 * @mixin
 */
export default {
    mixins: [WMenuMixin, WColorMixin],
    props: {
        /**
         * Sets the toolbar to dark mode
         */
        dark: {
            type: Boolean,
            default: false
        },
        /**
         * Set the flat prop on the toolbar
         */
        flatToolbar: {
            type: Boolean,
            default: false
        },
        /**
         * Title to display in the tile.
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * Title to display in the tile.
         */
        titleFontSize: {
            type: String,
            default: 'title'
        },
        /**
         * Title to display in the tile.
         */
        titleColor: {
            type: String,
            default: undefined
        },
        /**
         * Display the toolbar.
         */
        showToolbar: {
            type: Boolean,
            default: true
        },
        /**
         * Show a close icon in the top right (emits 'close').
         */
        showClose: {
            type: Boolean,
            default: false
        },
        /**
         * Show a hide arrow for the tile (to collapse the tile contents).
         */
        showToggleButton: {
            type: Boolean,
            default: false
        },
        /**
         * Value to set the 'show' boolean to.
         */
        showValue: {
            type: Boolean,
            default: true
        },
        /**
         * Set the height of the tile.
         */
        height: {
            type: String,
            default: null
        },
        /**
         * Use flat CSS styling (no border shadowing).
         */
        flat: {
            type: Boolean,
            default: false
        },
        /**
         * Set the tile width.
         * Pass in a boolean to inherit the width from the parent.
         */
        width: {
            type: [String, Number, Boolean],
            default: undefined
        },
        /**
         * Show the Menu buttons in the toolbar, used for custom visibility rules
         */
        showToolbarMenu: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        WMenu
    },
    methods: {
        emitClose () {
            /**
             * Close event.
             * @type {undefined}
             */
            this.$emit('close')
        }
    },
    computed: {
        hasMenuActions () {
            return !_.isEmpty(this.menuActions)
        },
        wCardTileProps () {
            const vm = this
            return vm.$props
        },
        wCardTileEvents () {
            const vm = this
            return {
                ...vm.mapActionEvents(vm.menuActions),
                close: vm.emitClose
            }
        },
        formTileStyle () {
            const width = this.width

            const marginStyle = {
                'margin-left': 'auto',
                'margin-right': 'auto'
            }

            if (typeof width ==='boolean') {
                return marginStyle
            }

            const widthStyle = {
                'max-width': typeof width === 'number' ? `${width}px` : width
            }

            return {
                ...widthStyle,
                ...marginStyle
            }
        }
    }
}
